import * as Yup from 'yup';

import { ALLOWED_CHARACTERS_REGEX, MAX_FILE_SIZE_5MB, PHONE_REGEX } from '@/common/constants';

export const inspectorSchema = (isEdit = false) => {
    return (
        Yup.object({
            companyName: Yup.string()
                .trim()
                .required('Company name is required')
                .matches(ALLOWED_CHARACTERS_REGEX, 'Input must only contain alphabets, numbers, commas, dots, slashes, and dashes.')
                .max(50, 'Max length is 50 characters'),
            type: Yup.array()
                .of(
                    Yup.string()
                        .oneOf(['SIRE | BIRE', 'Vetting'], 'Invalid selection for type')
                        .notOneOf([""] as any, 'Empty string is not a valid selection')
                )
                .min(1, 'At least one type is required')
                .required('Type is required'),
            reviewer: Yup.string()
                .trim()
                .required('Reviewer is required'),
            address: Yup.string()
                .trim()
                .required('Address is required')
                .matches(ALLOWED_CHARACTERS_REGEX, 'Input must only contain alphabets, numbers, commas, dots, slashes, and dashes.')
                .max(255, 'Max length is 255 characters'),
            country: Yup.string()
                .trim()
                .required('Country is required'),
            contactPerson: Yup.string()
                .trim()
                .required('Contact person is required')
                .matches(ALLOWED_CHARACTERS_REGEX, 'Input must only contain alphabets, numbers, commas, dots, slashes, and dashes.')
                .max(50, 'Max length is 50 characters'),
            email: Yup.string()
                .trim()
                .required('Nomination Email is required')
                .email('Enter a valid email address')
                .max(50, 'Max length is 50 characters'),
            alternateEmail: Yup.string()
                .trim()
                .required('Invoice Email is required')
                .email('Enter a valid email address')
                .max(50, 'Max length is 50 characters'),
            phone: Yup.string()
                .trim()
                .matches(PHONE_REGEX, 'Phone number must contain only digits or a "+" sign')
                .max(15, 'Max length is 15 characters'),
            dgt1: isEdit ?
                Yup.mixed()
                    .nullable()
                    .test('fileSize', 'File size is too large', (value) => {
                        if (value && (value as File).size > MAX_FILE_SIZE_5MB) {
                            return false;
                        }
                        return true;
                    }) :
                Yup.mixed()
                    .test('fileSize', 'File size is too large', (value) => {
                        if (!value) return false;
                        return (value as File).size <= MAX_FILE_SIZE_5MB;
                    })
                    .required('DGT-1 is required'),
            cor: isEdit ?
                Yup.mixed()
                    .nullable()
                    .test('fileSize', 'File size is too large', (value) => {
                        if (value && (value as File).size > MAX_FILE_SIZE_5MB) {
                            return false;
                        }
                        return true;
                    }) : Yup.mixed()
                        .test('fileSize', 'File size is too large', (value) => {
                            if (!value) return false;
                            return (value as File).size <= MAX_FILE_SIZE_5MB;
                        })
                        .required('COR is required'),
            companyProfile: isEdit ?
                Yup.mixed()
                    .nullable()
                    .test('fileSize', 'File size is too large', (value) => {
                        if (value && (value as File).size > MAX_FILE_SIZE_5MB) {
                            return false;
                        }
                        return true;
                    }) : Yup.mixed()
                        .nullable()
                        .test('fileSize', 'File size is too large', (value) => {
                            if (value && (value as File).size > MAX_FILE_SIZE_5MB) {
                                return false;
                            }
                            return true;
                        }),
            lapKeuAkhir: isEdit ?
                Yup.mixed()
                    .nullable()
                    .test('fileSize', 'File size is too large', (value) => {
                        if (value && (value as File).size > MAX_FILE_SIZE_5MB) {
                            return false;
                        }
                        return true;
                    }) : Yup.mixed()
                        .nullable()
                        .test('fileSize', 'File size is too large', (value) => {
                            if (value && (value as File).size > MAX_FILE_SIZE_5MB) {
                                return false;
                            }
                            return true;
                        }),
            bankDetails: isEdit ?
                Yup.mixed()
                    .nullable()
                    .test('fileSize', 'File size is too large', (value) => {
                        if (value && (value as File).size > MAX_FILE_SIZE_5MB) {
                            return false;
                        }
                        return true;
                    }) : Yup.mixed()
                        .nullable()
                        .test('fileSize', 'File size is too large', (value) => {
                            if (value && (value as File).size > MAX_FILE_SIZE_5MB) {
                                return false;
                            }
                            return true;
                        }),
            NIB: isEdit ?
                Yup.mixed()
                    .nullable()
                    .test('fileSize', 'File size is too large', (value) => {
                        if (value && (value as File).size > MAX_FILE_SIZE_5MB) {
                            return false;
                        }
                        return true;
                    }) : Yup.mixed()
                        .nullable()
                        .test('fileSize', 'File size is too large', (value) => {
                            if (value && (value as File).size > MAX_FILE_SIZE_5MB) {
                                return false;
                            }
                            return true;
                        }),
        }))
};
